import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/brand-close.png'
import _imports_1 from '../assets/images/brand-move.png'


const _withScopeId = n => (_pushScopeId("data-v-3308f86c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social_media_content_bg" }
const _hoisted_2 = { class: "link-add-wrapper" }
const _hoisted_3 = { class: "link-number" }
const _hoisted_4 = { class: "link-btn-wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "link-btn-content"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "link-btn-option" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " *置顶链接：每次更新后您的联卡上将显示“NEW”字样以示提醒 ", -1))
const _hoisted_9 = { class: "link-add-wrapper" }
const _hoisted_10 = { class: "link-number" }
const _hoisted_11 = { class: "link-btn-wrapper" }
const _hoisted_12 = {
  id: "dragcon",
  class: "media_content"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "link-btn-option sort-btn" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "move"
}, null, -1))
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddLinkShow = _resolveComponent("AddLinkShow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectSocialLinkTop.name ? 1 : 0) + "/1 ", 1),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.selectSocialLinkTop.name)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "link-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addTopLink && _ctx.addTopLink(...args)))
            }, " 点击添加 "))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "link-wrapper link-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTopLink && _ctx.addTopLink(...args)))
              }, [
                (_ctx.selectSocialLinkTop.icon)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.selectSocialLinkTop.icon,
                      alt: "",
                      class: "logo"
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.selectSocialLinkTop.name), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteTopLink && _ctx.deleteTopLink(...args)))
                })
              ])
            ])),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.selectSocialLinkNormalList.length) + "/" + _toDisplayString(_ctx.mediaCount), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectSocialLinkNormalList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "link-btn-content",
              key: item.name + index
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.editNormalLink(item, index)),
                class: "link-wrapper link-btn link-btn-content-normal"
              }, [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.icon,
                      alt: "",
                      class: "logo"
                    }, null, 8, _hoisted_14))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ], 8, _hoisted_13),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "close",
                  onClick: ($event: any) => (_ctx.deleteNormalLink(index))
                }, null, 8, _hoisted_17)
              ])
            ]))
          }), 128))
        ]),
        (_ctx.selectSocialLinkNormalList.length < _ctx.mediaCount)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "link-btn link-btn-normal",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNormalLink && _ctx.addNormalLink(...args)))
            }, " 点击添加 "))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.addLinkShow)
      ? (_openBlock(), _createBlock(_component_AddLinkShow, {
          key: 0,
          onDismissAddLinkShow: _ctx.dismissAddLinkShow,
          onSureAddLinkShow: _ctx.sureAddLinkShow,
          tempSocialLink: _ctx.selectSocialLink
        }, null, 8, ["onDismissAddLinkShow", "onSureAddLinkShow", "tempSocialLink"]))
      : _createCommentVNode("", true)
  ]))
}